function raise() {
  if (this.nextSibling) this.parentNode.appendChild(this);
}

export default function() {
  return this.each(raise);
}



//////////////////
// WEBPACK FOOTER
// ./~/d3/~/d3-selection/src/selection/raise.js
// module id = 5H52
// module chunks = 0